import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  ButtonGroup,
  Typography,
  useMediaQuery,
  Divider,
} from "@mui/material";
import KenTable from "../../../components/KenTable";
import { makeStyles } from "@mui/styles";
import NoData from "../../../assets/MyExams/NoData.png";
import { getCompletedExams } from "../../../utils/apiService";
import { formatDisplayDate } from "../../../utils/dateUtils";
// import { FaInfoCircle } from "react-icons/fa";
const useStyles = makeStyles(() => ({
  header: {
    fontSize: "20px !important",
    fontWeight: "500",
  },
  cardDataW: {
    background: "#FFF9EA",
    borderRadius: "4px",
    padding: "12px",
    color: "#545454",
    marginTop: "16px",
  },
  cardDataR: {
    background: "#EBF4EC",
    borderRadius: "4px",
    padding: "12px",
    color: "#545454",
    marginTop: "16px",
  },
  cardDataD: {
    background: "#FBEAEA",
    borderRadius: "4px",
    padding: "12px",
    color: "#545454",
    marginTop: "16px",
  },
}));

// const rows: any = [
//     { id: 1, name: "Network Analysis & Synthesis", code: "ECE101", exam: "End Semester", credits: 3, format: "Theory", type: "Regular", date: "13-08-2025", time: "09:00 am" },
//     { id: 2, name: "Digital Electronics", code: "ECE102", exam: "End Semester", credits: 3, format: "Theory", type: "Regular", date: "15-08-2025", time: "02:00 pm" },
//     { id: 3, name: "Signals & Systems", code: "ECE103", exam: "End Semester", credits: 4, format: "Theory", type: "Regular", date: "18-08-2025", time: "09:00 am" },
//     { id: 4, name: "Electromagnetics", code: "ECE104", exam: "End Semester", credits: 3, format: "Theory", type: "Regular", date: "20-08-2025", time: "02:00 pm" },
// ];

const columns = [
  { field: "name", headerName: "Course name" },
  { field: "code", headerName: "Course code" },
  { field: "exam", headerName: "Semester" },
  { field: "credits", headerName: "Credits" },
  { field: "format", headerName: "Format" },
  { field: "type", headerName: "Type" },
  { field: "date", headerName: "Date" },
  { field: "time", headerName: "Time" },
];

const Schedule = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState<"upcoming" | "completed">(
    "upcoming"
  );
  const [rows, setRows] = useState<any[]>([]);
  const now = new Date();
  const upcomingRows = rows.filter((exam) => exam.dateTime > now);
  const completedRows = rows.filter((exam) => exam.dateTime <= now);
  const activeRows = activeTab === "upcoming" ? upcomingRows : completedRows;

  useEffect(() => {
    getCompletedExams()
      .then((res) => {
        console.log(res?.data, "completed exams response");
        let response = res?.data;

        const formatIndianTime = (timeString: string) => {
          if (!timeString) return "--";
          const [timePart = "00:00:00"] = timeString.split(".");
          const [hourStr = "00", minuteStr = "00"] = timePart.split(":");
          let hours = parseInt(hourStr, 10);
          if (Number.isNaN(hours)) return "--";
          const minutes = minuteStr.padStart(2, "0");
          const period = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12;
          return `${hours.toString().padStart(2, "0")}:${minutes} ${period}`;
        };

        let tempArray = response?.scheduledAndUpcomingExams.map((item: any, index: number) => {
            const examDateTime = new Date(
              `${item.startDate}T${item.startTime}`
            );
            const readableTime = formatIndianTime(item.startTime);

            return {
              id: index + 1,
              name: item.courseName,
              code: item.courseCode,
              exam: item.semester,
              credits: item.credits,
              format: item.examFormat,
              type: item?.examType,
              date: formatDisplayDate(item.startDate),
              time: readableTime,
              status: item?.requestType,
              dateTime: examDateTime,
            };
          })
          // .filter((item: any) => item.status === "Exam Enrollment");

        setRows(tempArray);
      })
      .catch((err) => {
        console.error("Error in fetching completed exams:", err);
      });
  }, []);

  const renderMobileCards = () => (
    <Box mt={3} display="flex" flexDirection="column" gap={2}>
      <Box
        sx={{
          backgroundColor: "#FFF5DA",
          borderRadius: "12px",
          padding: 2,
          color: "#6D5200",
        }}
      >
        <Typography fontWeight={600} fontSize={16}>
          Schedule not available
        </Typography>
        <Typography fontSize={14} mt={0.5}>
          Your enrollment request is in review. The final exam schedule will be
          available once it is approved.
        </Typography>
      </Box>

      {activeRows.map((row: (typeof rows)[number]) => (
        <Box
          key={row.id}
          sx={{
            borderRadius: "16px",
            background: "linear-gradient(135deg, #F6F8FB 0%, #FFFFFF 100%)",
            padding: 2,
            boxShadow: "0px 1px 3px rgba(15, 23, 42, 0.12)",
          }}
        >
          <Typography fontWeight={600} fontSize={16}>
            {row.name}
          </Typography>
          <Typography fontSize={14} color="text.secondary" mt={0.5}>
            {row.code} | {row.credits} Credits
          </Typography>
          <Divider sx={{ my: 1.5, borderColor: "rgb(0 0 0 / 46%)" }} />
          <Box display="flex" flexDirection="row" gap={2} flexWrap="wrap">
            <Box display="flex" justifyContent="space-between">
              <Typography fontSize={13} color="text.secondary">
                Type:&nbsp;
              </Typography>
              <Typography fontSize={13} fontWeight={500}>
                {row.type}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography fontSize={13} color="text.secondary">
                Format:&nbsp;
              </Typography>
              <Typography fontSize={13} fontWeight={500}>
                {row.format}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography fontSize={13} color="text.secondary">
                Exam:&nbsp;
              </Typography>
              <Typography fontSize={13} fontWeight={500}>
                {row.exam}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography fontSize={13} color="text.secondary">
                Date:&nbsp;
              </Typography>
              <Typography fontSize={13} fontWeight={500}>
                {row.date}
              </Typography>
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Typography fontSize={13} color="text.secondary">
                Time:&nbsp;
              </Typography>
              <Typography fontSize={13} fontWeight={500}>
                {row.time}
              </Typography>
            </Box>
          </Box>
        </Box>
      ))}

      {/* {activeRows.length > 0 && (
                <Box
                    sx={{
                        borderRadius: "14px",
                        backgroundColor: "#F0FFF4",
                        padding: 2,
                        border: "1px solid #34A85333",
                        boxShadow: "0px 2px 6px rgba(34, 197, 94, 0.15)",
                    }}
                >
                    <Typography fontWeight={600} fontSize={15} color="#1F7A3D">
                        Enrollment successful
                    </Typography>
                    <Typography fontSize={13} color="#1F7A3D" mt={0.5}>
                        The final schedule will be available once the enrollment is approved.
                    </Typography>
                </Box>
            )} */}

      {!activeRows.length && (
        <Box
          sx={{
            borderRadius: "12px",
            border: "1px dashed #CBD5E1",
            padding: 2,
            textAlign: "center",
            color: "#475569",
          }}
        >
          <Typography fontWeight={500}>
            No {activeTab === "upcoming" ? "upcoming" : "completed"} exams yet.
          </Typography>
          <Typography fontSize={13} mt={0.5}>
            Check back later once the schedule is published.
          </Typography>
        </Box>
      )}
    </Box>
  );

  return (
    <Box>
      {/* Tab Buttons */}
      <Box className="d-flex align-items-center justify-content-between flex-wrap gap-3 w-100">
        <Box>
          {/* <Typography className={classes.header}>
            Enrolled courses - Semester II
          </Typography> */}
          {/* <Typography sx={{ color: "#B28820" }}>Enrollment under review</Typography>
                    <Typography sx={{ color: "#338137" }}>Exam schedule published</Typography>
                    <Typography sx={{ color: "#C02B2B" }}>Enrollment under Not Approved</Typography> */}
        </Box>
        <ButtonGroup
          sx={{
            backgroundColor: "#F6F8FB",
            borderRadius: isMobile ? "5px" : "8px",
            overflow: "hidden",
            width: isMobile ? "100%" : "auto",
            "& .MuiButtonGroup-grouped": {
              border: "none",
              width: isMobile ? "100%" : "auto",
              minWidth: isMobile ? "0px" : "140px",
              height: "48px",
              fontSize: "14px",
              fontWeight: 500,
              textTransform: "none",
              borderRadius: isMobile ? "5px" : "8px !important",
              margin: "4px",
              transition: "all 0.3s ease",
            },
          }}
        >
          {["upcoming", "completed"].map((tab) => (
            <Button
              key={tab}
              onClick={() => setActiveTab(tab as "upcoming" | "completed")}
              sx={{
                backgroundColor: activeTab === tab ? "#1a1a2e" : "transparent",
                color: activeTab === tab ? "white" : "#666",
                "&:hover": {
                  backgroundColor: activeTab === tab ? "#1a1a2e" : "#e0e0e0",
                },
              }}
            >
              {tab === "upcoming" ? "Upcoming Exams" : "Completed Exams"}
            </Button>
          ))}
        </ButtonGroup>
      </Box>

      {/* Table */}
      <Box>
        {isMobile
          ? renderMobileCards()
          : activeRows.length > 0 && (
              <Box className="mt-4">
                <KenTable
                  columns={columns}
                  rows={activeRows}
                  // footer={
                  //     <Box display="flex" justifyContent="end" alignItems="center" gap={4}>
                  //         <Button variant="secondary" sx={{ color: 'white !important' }} >
                  //             Download hall ticket
                  //         </Button>
                  //     </Box>
                  // }
                />
              </Box>
            )}
        <>
          {/* {
                    !isMobile && activeRows.length > 0 && (
                        <>
                            <Box className={classes.cardDataW}>
                                <Typography sx={{ fontSize: "14px", display: "flex", alignItems: "center" }}>
                                    Schedule not available
                                </Typography>
                                <Typography sx={{ fontSize: '14px' }}>Your enrollment request is in review. The final exam schedule will be available once it is approved.</Typography>
                            </Box>
                            <Box className={classes.cardDataR}>
                                <Typography sx={{ fontSize: '14px' }}>
                                    Schedule published</Typography>
                                <Typography sx={{ fontSize: '14px' }}>The final exam schedule is now available. You can download your hall ticket for the exam..</Typography>
                            </Box>
                            <Box className={classes.cardDataD}>
                                <Typography sx={{ fontSize: '14px' }}>
                                    Schedule not available</Typography>
                                <Typography sx={{ fontSize: '14px' }}>Your enrollment request has not been approved. Please reach out to the admin for assistance.</Typography>
                            </Box>
                        </>
                    )
                } */}
        </>
        {!activeRows.length && !isMobile && (
          <Box
            className="d-flex  flex-column justify-content-center align-items-center mt-4 "
            sx={{ height: "400px" }}
          >
            <img src={NoData} />
            <Typography className="mt-2 fw-bold">
              Exam Schedule Not Yet Available
            </Typography>
            {/* <Typography className="w-50 text-center mt-2">
              <p>
                Your enrollment request has not been approved. Please reach out
                to the admin for assistance.
              </p>
            </Typography> */}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Schedule;